var map = {
	"./ai.jpg": "aae3",
	"./applicant.jpg": "7744",
	"./ask.jpg": "6b65",
	"./certificates.jpg": "a361",
	"./cv.jpg": "923e",
	"./digital-asset.jpg": "a5b4",
	"./employee-information.jpg": "cf6e",
	"./employee.jpg": "9412",
	"./evaluation.jpg": "fab6",
	"./exam.jpg": "4425",
	"./face-scan.jpg": "4d7e",
	"./holiday.jpg": "08c9",
	"./hr-document.jpg": "10bb",
	"./key.jpg": "c659",
	"./leave-request.jpg": "aadc",
	"./manually.jpg": "c352",
	"./news.jpg": "6252",
	"./photos.jpg": "578b",
	"./project.jpg": "a829",
	"./sale-order-v2.jpg": "2f13",
	"./sale-order.jpg": "356a",
	"./skill.jpg": "bb84",
	"./support.jpg": "6f8c",
	"./team.jpg": "cf01",
	"./training-statistics.jpg": "4163",
	"./training-v2.jpg": "45d2",
	"./training.jpg": "a5da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c24";